import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../../api';
import ViewWorld from './ViewWorld';
import { WorldDetail } from '../../api/types/shared';
import ResponsiveLayout from '../navigation/ResponsiveLayout';

const World = () => {
  const { slug } = useParams<{ slug: string }>();
  const [world, setWorld] = useState<WorldDetail | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchWorld = async () => {
      if (!slug) {
        setError('No world slug provided');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const worldData = await api.worlds.get(slug);
        setWorld(worldData);
        setError(null);
      } catch (err) {
        console.error('Failed to fetch world:', err);
        setError('Failed to load world. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchWorld();
  }, [slug]);

  if (loading) {
    return (
      <ResponsiveLayout fullScreen>
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading world...</p>
        </div>
      </ResponsiveLayout>
    );
  }

  if (error || !world) {
    return (
      <ResponsiveLayout fullScreen>
        <div className="error-container">
          <p>{error || 'Failed to load world'}</p>
        </div>
      </ResponsiveLayout>
    );
  }

  return (
    <ResponsiveLayout fullScreen>
      <ViewWorld world={world} />
    </ResponsiveLayout>
  );
};

export default World; 